import { ActionMenuItem } from "components/personnelAndFleet/common/ActionCell";
import { FleetVehicleStatus } from "enums/FleetEnums";
import { FleetVehicle } from "models/FleetVehicle";

export type FleetVehicleActionHandlers = {
	onEditVehicle: (vehicle: FleetVehicle) => void;
	onDuplicateVehicle: (vehicle: FleetVehicle) => void;
	onDeactivateVehicle: (vehicle: FleetVehicle) => void;
	onActivateVehicle: (vehicle: FleetVehicle) => void;
};

export function getFleetVehicleActionItems(
	vehicle: FleetVehicle,
	handlers: FleetVehicleActionHandlers
): ActionMenuItem[] {
	const isActive = vehicle.status === FleetVehicleStatus.ACTIVE;

	return [
		{ label: "Edit", onClick: () => handlers.onEditVehicle(vehicle) },
		{ label: "Duplicate", onClick: () => handlers.onDuplicateVehicle(vehicle) },
		isActive
			? { label: "Deactivate", onClick: () => handlers.onDeactivateVehicle(vehicle), isDanger: true }
			: { label: "Activate", onClick: () => handlers.onActivateVehicle(vehicle) }
	];
}
